import { oneYearInDays } from 'helpers/constants';
import { routes } from 'routes';


export const navigateToReportingPage = (_, history, asset) => {
    // TODO: Used legacyAssetId as search params for reports search instead of assetID.
    history.push({ pathname: routes.Reports, search: new URLSearchParams({ assetID: asset.id, reportingPeriod: oneYearInDays }).toString(), state: asset });
};
